import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route, Navigate, Routes } from 'react-router-dom'

import SignUp from 'pages/SignUp/SignUp'
import SignIn from 'pages/SignIn/SignIn'
import EmailConfirmation from 'features/EmailConfirmation/EmailConfirmation'
import Portal from 'components/Portal/Portal'
import Settings from 'pages/Settings/Settings'
import PageNotFound from 'pages/PageNotFound/PageNotFound'
// import Storybook from 'pages/Storybook'
import { CRUDUserPage } from 'pages/CRUDUser/CRUDUserPage'
import { RFPList } from 'features/RFP/RFPList/RFPList'
import { RFPDetails } from 'features/RFP/RFPDetails'
import { routes } from './Config/config.routes'
import { Contacts } from 'pages/Contracts/Contracts'
import { Calendar } from 'pages/Calendar/Calendar'
import { ContractDetails } from 'features/ContractDetails'
import { HealthSystemDetails } from 'features/MyCommunity/HealthSystems/HealthSystemDetails/HealthSystemDetails'
import { VendorDetails as CommunityVendorDetails } from 'features/MyCommunity/Vendors/VendorDetails/VendorDetails'
import { VendorCreation } from 'features/MyCommunity/Vendors/VendorCreation/VendorCreation'
import { Dashboard } from 'pages/Dashboard/Dashboard'
import { Financials } from 'pages/Financials/Financials'

import { getUser } from 'redux/store/user/getters'
import Chats from 'pages/Chats/Chats'
import { ROLES } from 'features/Permission'
import FANumber from '../pages/FANumber/FANumber'
import FACode from '../pages/FACode/FACode'
import TermsOfUsePage from '../pages/TermsOfUse/TermsOfUse'
import LandingPage from '../pages/Landing/Landing'
import useRouter from 'hooks/useRouter'
import { ProductRequest } from '../pages/ProductRequests/ProductRequest'
import { PRSDetails } from '../features/PRS/PRSDetails'
import { MyCommunity } from '../pages/MyCommunity/MyCommunity'
import { getLocalLastPage, setLocalLastPage } from '../helper/common'
import { getVendorInfo } from 'redux/store/vendorInfo/getters'
import { ClinicalReviewPage } from '../pages/ClinicalReview/ClinicalReviewPage'
import { RequestForAnalysisContainer } from '../pages/RequestForAnalysisDetaisPage/RequestForAnalysisContainer'
import ContractPipelineDetails from 'features/ContractsPipelineDetails/ContractPipelineDetails'
import ContractBulkCreation from '../features/ContractBulkCreation/ContractBulkCreation'
import VerifyEmail from 'pages/VerifyEmail/VerifyEmail'
import PendingApproval from '../pages/PendindApproval/PendingApproval'
import { InvoiceData } from '../pages/InvoiceData/InvoiceData'
import { CompliancePage } from '../pages/Compliance/Compliance'
import MarketInsights from '../pages/MarketInsights/MarketInsights'
import { CompleteProfile } from '../pages/CompleteProfile/CompleteProfile'
import { SelfSignUp } from '../pages/SelfSignUp/SelfSignUp'
import { ContractCategoryDetails } from '../features/ContractCategoryDetails/ContractCategoryDetails'
import LinkExpired from '../pages/LinkExpired/LinkExpired'
import { CONTRACTS_PAGE_OPTIONS } from '../features/Contracts/routesConstants'
import { AddGpoDetails } from '../pages/AddGpo/AddGpo'
import DescopeSignIn from '../pages/DescopeSignIn/DescopeSignIn'
import UserNotExist from '../pages/UserNotExist/UserNotExist'
import { HSDetailsContainer } from '../features/MyCommunity/MyOrganizationCommunity/HSDetails/HSDetailsContainer'
import { SavingGoalsPage } from '../pages/SavingGoals/SavingGoalsPage'
import { AdditionalValuesPage } from '../pages/AdditionaValues/AdditionalValuesPage'
import { HospitalDetailsContainer } from '../features/MyCommunity/MyOrganizationCommunity/HSDetails/HospitalsTable/HospitalDetails/HospitalDetailsContainer'
import { BankAccountDetailsContainer } from 'features/BankAccount/BankAccountDetails/BankAccountDetailsContainer'

export default (): JSX.Element => {
  const user = useSelector(getUser)
  const { pathname } = useRouter()
  // const isLanding = false
  const HospitalUserAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.clinicalReview} element={<ClinicalReviewPage />} />
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.contracts}>
          <Route index element={<Contacts />} />
          <Route path=":id" element={<ContractDetails />}>
            <Route path=":tab" element={<ContractDetails />}>
              <Route path=":subtab" element={<ContractDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>

        <Route path="*" element={<Navigate to={routes.bidding} replace />} />
      </>
    ),
    []
  )

  const vendor = useSelector(getVendorInfo)
  const hasVendorFullAccess = vendor?.vendor_permission === 'full_access'

  const VendorCSAppRoutes = useMemo(() => {
    return (
      <>
        {hasVendorFullAccess && (
          <>
            <Route path={routes.bidding}>
              <Route index element={<RFPList />} />
              <Route path="rfp/:id" element={<RFPDetails />}>
                <Route path=":tab" element={<RFPDetails />}>
                  <Route path=":subtab" element={<RFPDetails />} />
                </Route>
              </Route>
            </Route>

            <Route path={routes.financials} element={<Financials />}>
              <Route path=":tab" element={<Financials />} />
              <Route path=":tab/:type" element={<Financials />} />
            </Route>

            <Route path={routes.contracts}>
              <Route index element={<Contacts />} />
              <Route path=":id" element={<ContractDetails />}>
                <Route path=":tab" element={<ContractDetails />}>
                  <Route path=":subtab" element={<ContractDetails />} />
                </Route>
              </Route>
            </Route>
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}${routes.contractCategories}/:id`}
              element={<ContractCategoryDetails />}
            >
              <Route path=":tab" element={<ContractCategoryDetails />}>
                <Route path=":subtab" element={<ContractCategoryDetails />} />
              </Route>
            </Route>

            <Route path={routes.calendar} element={<Calendar />} />
            <Route path={routes.marketInsights} element={<MarketInsights />} />
            <Route
              path={routes.myCommunity + '/health-system/:id'}
              element={<HealthSystemDetails />}
            >
              <Route path=":tab" element={<HealthSystemDetails />} />
            </Route>
            <Route
              path={routes.myCommunity + '/vendor_details/:id'}
              element={<CommunityVendorDetails />}
            >
              <Route path=":tab" element={<CommunityVendorDetails />} />
            </Route>
            <Route path={routes.myCommunity} element={<MyCommunity />}>
              <Route path=":tab" element={<MyCommunity />} />
              <Route path=":tab/:type" element={<MyCommunity />} />
            </Route>
          </>
        )}

        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path=":id" element={<Chats />} />
        </Route>
        <Route path={routes.chat} element={<Chats />} />

        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route path=":id" element={<PRSDetails />}>
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>

        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>

        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to={hasVendorFullAccess ? routes.bidding : routes.productRequests}
              replace
            />
          }
        />
      </>
    )
  }, [hasVendorFullAccess])

  const VendorCAAppRoutes = useMemo(() => {
    return (
      <>
        {hasVendorFullAccess && (
          <>
            <Route path={routes.bidding}>
              <Route index element={<RFPList />} />
              <Route path="rfp/:id" element={<RFPDetails />}>
                <Route path=":tab" element={<RFPDetails />}>
                  <Route path=":subtab" element={<RFPDetails />} />
                </Route>
              </Route>
            </Route>

            <Route path={routes.contracts}>
              <Route index element={<Contacts />} />
              <Route path=":id" element={<ContractDetails />}>
                <Route path=":tab" element={<ContractDetails />}>
                  <Route path=":subtab" element={<ContractDetails />} />
                </Route>
              </Route>
            </Route>
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}${routes.contractCategories}/:id`}
              element={<ContractCategoryDetails />}
            >
              <Route path=":tab" element={<ContractCategoryDetails />}>
                <Route path=":subtab" element={<ContractCategoryDetails />} />
              </Route>
            </Route>

            <Route path={routes.calendar} element={<Calendar />} />

            <Route path={routes.financials} element={<Financials />}>
              <Route path=":tab" element={<Financials />} />
              <Route path=":tab/:type" element={<Financials />} />
            </Route>

            <Route path={routes.marketInsights} element={<MarketInsights />} />
            <Route
              path={routes.myCommunity + '/health-system/:id'}
              element={<HealthSystemDetails />}
            >
              <Route path=":tab" element={<HealthSystemDetails />} />
            </Route>
            <Route
              path={routes.myCommunity + '/vendor_details/:id'}
              element={<CommunityVendorDetails />}
            >
              <Route path=":tab" element={<CommunityVendorDetails />} />
            </Route>
            <Route
              path={`${routes.myCommunity}${routes.myOrganization}${routes.bankAccounts}/:id`}
              element={<BankAccountDetailsContainer />}
            />
            <Route path={routes.myCommunity} element={<MyCommunity />}>
              <Route path=":tab" element={<MyCommunity />} />
              <Route path=":tab/:type" element={<MyCommunity />} />
            </Route>
          </>
        )}
        <Route path={routes.chat} element={<Chats />} />
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>

        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />

        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path=":id" element={<Chats />} />
        </Route>

        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route path=":id" element={<PRSDetails />}>
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>

        {/* Fallback Route */}
        <Route
          path="*"
          element={
            <Navigate
              to={
                hasVendorFullAccess ? routes.contracts : routes.productRequests
              }
              replace
            />
          }
        />
      </>
    )
  }, [hasVendorFullAccess])

  const DefaultAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route path={routes.savingGoals} element={<SavingGoalsPage />} />
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route
          path={routes.contracts + routes.centralRepository + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route
          path={routes.contracts + '/:type' + routes.bulkContractCreation}
          element={<ContractBulkCreation />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractPipeline + '/:id'}
          element={<ContractPipelineDetails />}
        >
          <Route path=":tab" element={<ContractPipelineDetails />} />
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        {/*<Route path={routes.purchaseOrders} element={<PurchaseOrders />} />*/}
        <Route path={routes.invoiceData} element={<InvoiceData />}>
          <Route path=":tab" element={<InvoiceData />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:hsId/bank_accounts/:id`}
          element={<BankAccountDetailsContainer />}
        />
        <Route path="*" element={<Navigate to={routes.dashboard} replace />} />
      </>
    ),
    []
  )
  const CommunityPresident = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route path={routes.savingGoals} element={<SavingGoalsPage />} />
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={routes.contracts + '/:type' + routes.bulkContractCreation}
          element={<ContractBulkCreation />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        {/*<Route path={routes.purchaseOrders} element={<PurchaseOrders />} />*/}
        <Route path={routes.invoiceData} element={<InvoiceData />}>
          <Route path=":tab" element={<InvoiceData />} />
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/bank_accounts/:id`}
          element={<BankAccountDetailsContainer />}
        />
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.dashboard} replace />} />
      </>
    ),
    []
  )

  const VendorFinanceOfficerAppRoutes = useMemo(() => {
    return (
      <>
        {hasVendorFullAccess && (
          <>
            <Route path={routes.marketInsights} element={<MarketInsights />} />
            <Route path={routes.financials} element={<Financials />}>
              <Route path=":tab" element={<Financials />} />
              <Route path=":tab/:type" element={<Financials />} />
            </Route>
            <Route path={routes.contracts}>
              <Route index element={<Contacts />} />
              <Route path=":id" element={<ContractDetails />}>
                <Route path=":tab" element={<ContractDetails />}>
                  <Route path=":subtab" element={<ContractDetails />} />
                </Route>
              </Route>
            </Route>
            <Route
              path={`${routes.contracts}${routes.contractCategories}/:id`}
              element={<ContractCategoryDetails />}
            >
              <Route path=":tab" element={<ContractCategoryDetails />}>
                <Route path=":subtab" element={<ContractCategoryDetails />} />
              </Route>
            </Route>
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
              element={<Contacts />}
            />
            <Route
              path={routes.myCommunity + '/health-system/:id'}
              element={<HealthSystemDetails />}
            >
              <Route path=":tab" element={<HealthSystemDetails />} />
            </Route>
            <Route
              path={routes.myCommunity + '/vendor_details/:id'}
              element={<CommunityVendorDetails />}
            >
              <Route path=":tab" element={<CommunityVendorDetails />} />
            </Route>
            <Route path={routes.myCommunity} element={<MyCommunity />}>
              <Route path=":tab" element={<MyCommunity />} />
              <Route path=":tab/:type" element={<MyCommunity />} />
            </Route>
            <Route path={routes.calendar} element={<Calendar />} />
          </>
        )}

        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>

        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />

        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path=":id" element={<Chats />} />
        </Route>

        <Route
          path="*"
          element={
            <Navigate
              to={hasVendorFullAccess ? routes.financials : routes.settings}
              replace
            />
          }
        />
      </>
    )
  }, [hasVendorFullAccess])

  const CommonsLegalAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.contracts}>
          <Route index element={<Contacts />} />
          <Route path=":id" element={<ContractDetails />}>
            <Route path=":tab" element={<ContractDetails />}>
              <Route path=":subtab" element={<ContractDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.contracts} replace />} />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
      </>
    ),
    []
  )

  const CommonsAnalystAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.opportunityAnalysis + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.contracts} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
      </>
    ),
    []
  )

  const CommonsStAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.settings} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.contracts}>
          <Route index element={<Contacts />} />
          <Route path=":id" element={<ContractDetails />}>
            <Route path=":tab" element={<ContractDetails />}>
              <Route path=":subtab" element={<ContractDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
      </>
    ),
    []
  )
  const CommonsVpAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route
          path={routes.contracts + routes.opportunityAnalysis + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route
          path={routes.contracts + '/:type' + routes.bulkContractCreation}
          element={<ContractBulkCreation />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractPipeline + '/:id'}
          element={<ContractPipelineDetails />}
        >
          <Route path=":tab" element={<ContractPipelineDetails />} />
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path={routes.gpo} element={<AddGpoDetails />}>
          <Route path={`${routes.gpo}/:id`} element={<AddGpoDetails />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.contracts} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
      </>
    ),
    []
  )
  const CommonsCCAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.opportunityAnalysis + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.contracts} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
      </>
    ),
    []
  )
  const CommonsCSAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.opportunityAnalysis + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + '/:type' + routes.bulkContractCreation}
          element={<ContractBulkCreation />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractPipeline + '/:id'}
          element={<ContractPipelineDetails />}
        >
          <Route path=":tab" element={<ContractPipelineDetails />} />
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.contracts} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
      </>
    ),
    []
  )

  const RevenueCycleAdvisorAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.settings} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route path={routes.invoiceData} element={<InvoiceData />}>
          <Route path=":tab" element={<InvoiceData />} />
        </Route>
      </>
    ),
    []
  )

  const AnalistAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route path={routes.savingGoals} element={<SavingGoalsPage />} />
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route
          path={routes.contracts + routes.centralRepository + '/:id'}
          element={<RequestForAnalysisContainer />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>

        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>

        <Route path={routes.invoiceData} element={<InvoiceData />}>
          <Route path=":tab" element={<InvoiceData />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.compliance} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
      </>
    ),
    []
  )

  const VLegalVAnalystLegalAppRoutes = useMemo(() => {
    return (
      <>
        {hasVendorFullAccess && (
          <>
            <Route
              path={`${routes.contracts}${routes.contractCategories}/:id`}
              element={<ContractCategoryDetails />}
            >
              <Route path=":tab" element={<ContractCategoryDetails />}>
                <Route path=":subtab" element={<ContractCategoryDetails />} />
              </Route>
            </Route>

            <Route path={routes.contracts}>
              <Route index element={<Contacts />} />
              <Route path=":id" element={<ContractDetails />}>
                <Route path=":tab" element={<ContractDetails />}>
                  <Route path=":subtab" element={<ContractDetails />} />
                </Route>
              </Route>
            </Route>
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
              element={<Contacts />}
            />
            <Route
              path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
              element={<Contacts />}
            />

            <Route path={routes.marketInsights} element={<MarketInsights />} />

            <Route path={routes.financials} element={<Financials />}>
              <Route path=":tab" element={<Financials />} />
              <Route path=":tab/:type" element={<Financials />} />
            </Route>

            <Route path={routes.bidding}>
              <Route index element={<RFPList />} />
              <Route path="rfp/:id" element={<RFPDetails />}>
                <Route path=":tab" element={<RFPDetails />}>
                  <Route path=":subtab" element={<RFPDetails />} />
                </Route>
              </Route>
            </Route>

            <Route path={routes.calendar} element={<Calendar />} />
            <Route
              path={routes.myCommunity + '/health-system/:id'}
              element={<HealthSystemDetails />}
            >
              <Route path=":tab" element={<HealthSystemDetails />} />
            </Route>
            <Route
              path={routes.myCommunity + '/vendor_details/:id'}
              element={<CommunityVendorDetails />}
            >
              <Route path=":tab" element={<CommunityVendorDetails />} />
            </Route>
            <Route path={routes.myCommunity} element={<MyCommunity />}>
              <Route path=":tab" element={<MyCommunity />} />
              <Route path=":tab/:type" element={<MyCommunity />} />
            </Route>
          </>
        )}

        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />

        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path=":id" element={<Chats />} />
        </Route>

        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>

        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route path=":id" element={<PRSDetails />}>
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to={
                hasVendorFullAccess ? routes.contracts : routes.productRequests
              }
              replace
            />
          }
        />
      </>
    )
  }, [hasVendorFullAccess])

  const LegalAppRoutes = useMemo(() => {
    return (
      <>
        <>
          <Route
            path={`${routes.contracts}${routes.contractCategories}/:id`}
            element={<ContractCategoryDetails />}
          >
            <Route path=":tab" element={<ContractCategoryDetails />}>
              <Route path=":subtab" element={<ContractCategoryDetails />} />
            </Route>
          </Route>

          <Route path={routes.contracts}>
            <Route index element={<Contacts />} />
            <Route path=":id" element={<ContractDetails />}>
              <Route path=":tab" element={<ContractDetails />}>
                <Route path=":subtab" element={<ContractDetails />} />
              </Route>
            </Route>
          </Route>
          <Route
            path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />

          <Route path={routes.marketInsights} element={<MarketInsights />} />

          <Route path={routes.financials} element={<Financials />}>
            <Route path=":tab" element={<Financials />} />
            <Route path=":tab/:type" element={<Financials />} />
          </Route>

          <Route path={routes.bidding}>
            <Route index element={<RFPList />} />
            <Route path="rfp/:id" element={<RFPDetails />}>
              <Route path=":tab" element={<RFPDetails />}>
                <Route path=":subtab" element={<RFPDetails />} />
              </Route>
            </Route>
          </Route>

          <Route path={routes.calendar} element={<Calendar />} />
          <Route
            path={routes.myCommunity + '/health-system/:id'}
            element={<HealthSystemDetails />}
          >
            <Route path=":tab" element={<HealthSystemDetails />} />
          </Route>
          <Route
            path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
            element={<HSDetailsContainer />}
          >
            <Route path=":tab" element={<HSDetailsContainer />} />
          </Route>
          <Route
            path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
            element={<HospitalDetailsContainer />}
          >
            <Route path=":tab" element={<HospitalDetailsContainer />} />
          </Route>
          <Route
            path={routes.myCommunity + '/vendor_details/:id'}
            element={<CommunityVendorDetails />}
          >
            <Route path=":tab" element={<CommunityVendorDetails />} />
          </Route>
          <Route path={routes.myCommunity} element={<MyCommunity />}>
            <Route path=":tab" element={<MyCommunity />} />
            <Route path=":tab/:type" element={<MyCommunity />} />
          </Route>
        </>

        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />

        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path=":id" element={<Chats />} />
        </Route>

        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>

        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route path=":id" element={<PRSDetails />}>
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to={
                hasVendorFullAccess ? routes.contracts : routes.productRequests
              }
              replace
            />
          }
        />
      </>
    )
  }, [hasVendorFullAccess])

  const HospitalAdminAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.bidding} replace />} />

        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.contracts}>
          <Route index element={<Contacts />} />
          <Route path=":id" element={<ContractDetails />}>
            <Route path=":tab" element={<ContractDetails />}>
              <Route path=":subtab" element={<ContractDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:hsId/hospitals/:hospitalId/bank_accounts/:id`}
          element={<BankAccountDetailsContainer />}
        />
      </>
    ),
    []
  )

  const ClinicalCoordinatorAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor-creation'}
          element={<VendorCreation />}
        />
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path={routes.contracts + '/:type' + routes.bulkContractCreation}
          element={<ContractBulkCreation />}
        />
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route path={routes.compliance} element={<CompliancePage />} />
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route path={routes.productRequests}>
          <Route index element={<ProductRequest />} />
          <Route
            path={`${routes.productRequests}/:id`}
            element={<PRSDetails />}
          >
            <Route path=":tab" element={<PRSDetails />} />
          </Route>
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route
          path="*"
          element={<Navigate to={routes.myCommunity} replace />}
        />
      </>
    ),
    []
  )

  const SalesRepresentativeAppRoutes = useMemo(
    () => (
      <>
        <Route path={routes.contracts}>
          <Route index element={<Contacts />} />
          <Route path=":id" element={<ContractDetails />}>
            <Route path=":tab" element={<ContractDetails />}>
              <Route path=":subtab" element={<ContractDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.bidding}>
          <Route index element={<RFPList />} />
          <Route path="rfp/:id" element={<RFPDetails />}>
            <Route path=":tab" element={<RFPDetails />}>
              <Route path=":subtab" element={<RFPDetails />} />
            </Route>
          </Route>
        </Route>
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[0].value}`}
          element={<Contacts />}
        />
        <Route
          path={`${routes.contracts}/${CONTRACTS_PAGE_OPTIONS[2].value}`}
          element={<Contacts />}
        />
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path="*" element={<Navigate to={routes.chat} replace />} />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
      </>
    ),
    []
  )
  const GpoPresidentRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route path={routes.gpo} element={<AddGpoDetails />}>
          <Route path={`${routes.gpo}/:id`} element={<AddGpoDetails />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={routes.myCommunity} replace />}
        />
      </>
    ),
    []
  )
  const GpoAnalystRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.financials} replace />} />
      </>
    ),
    []
  )
  const GpoLegalRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.settings} replace />} />
      </>
    ),
    []
  )
  const CommunityFinanceAppRoutes = useMemo(
    () => (
      <>
        <Route
          path={`${routes.createUserProfile}/:id`}
          element={<CRUDUserPage />}
        />
        <Route
          path={routes.myCommunity + '/health-system/:id'}
          element={<HealthSystemDetails />}
        >
          <Route path=":tab" element={<HealthSystemDetails />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id`}
          element={<HSDetailsContainer />}
        >
          <Route path=":tab" element={<HSDetailsContainer />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:id/hospitals/:hospitalId`}
          element={<HospitalDetailsContainer />}
        >
          <Route path=":tab" element={<HospitalDetailsContainer />} />
        </Route>
        <Route
          path={routes.myCommunity + '/vendor_details/:id'}
          element={<CommunityVendorDetails />}
        >
          <Route path=":tab" element={<CommunityVendorDetails />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:hsId/bank_accounts/:id`}
          element={<BankAccountDetailsContainer />}
        />
        <Route
          path={`${routes.myCommunity}${routes.myOrganization}/health_systems/:hsId/hospitals/:hospitalId/bank_accounts/:id`}
          element={<BankAccountDetailsContainer />}
        />
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.contracts} element={<Contacts />}>
          <Route path=":type" element={<Contacts />} />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[0].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[1].value}`}
            element={<Contacts />}
          />
          <Route
            path={`:type/${CONTRACTS_PAGE_OPTIONS[2].value}`}
            element={<Contacts />}
          />
        </Route>
        <Route
          path={routes.contracts + '/:type/:id'}
          element={<ContractDetails />}
        >
          <Route path=":tab" element={<ContractDetails />}>
            <Route path=":subtab" element={<ContractDetails />} />
          </Route>
        </Route>
        <Route
          path={routes.contracts + routes.contractCategories + '/:id'}
          element={<ContractCategoryDetails />}
        >
          <Route path=":tab" element={<ContractCategoryDetails />}>
            <Route path=":subtab" element={<ContractCategoryDetails />} />
          </Route>
        </Route>
        <Route path={routes.chat}>
          <Route index element={<Chats />} />
          <Route path={`${routes.chat}/:id`} element={<Chats />} />
        </Route>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.calendar} element={<Calendar />} />
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.additionalValues}
          element={<AdditionalValuesPage />}
        />
        <Route path={routes.savingGoals} element={<SavingGoalsPage />} />
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.financials} replace />} />
      </>
    ),
    []
  )
  const GpoContractStewardRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path="*" element={<Navigate to={routes.financials} replace />} />
      </>
    ),
    []
  )
  const GpoFinOfficerRoutes = useMemo(
    () => (
      <>
        <Route path={routes.settings} element={<Settings />}>
          <Route path=":tab" element={<Settings />} />
          <Route path=":tab/:type" element={<Settings />} />
        </Route>
        <Route path={routes.financials} element={<Financials />}>
          <Route path=":tab" element={<Financials />} />
          <Route path=":tab/:type" element={<Financials />} />
        </Route>
        <Route path={routes.myCommunity} element={<MyCommunity />}>
          <Route path=":tab" element={<MyCommunity />} />
          <Route path=":tab/:type" element={<MyCommunity />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={routes.myCommunity} replace />}
        />
      </>
    ),
    []
  )

  const AppRoutes = useMemo(() => {
    switch (user.role) {
      case ROLES.HOSPITAL_USER:
        return HospitalUserAppRoutes
      case ROLES.VENDOR_CONTRACT_STEWARD:
        return VendorCSAppRoutes
      case ROLES.VENDOR_CONTRACT_ADMIN:
        return VendorCAAppRoutes
      case ROLES.HOSPITAL_ADMIN:
        return HospitalAdminAppRoutes
      case ROLES.CLINICAL_COORDINATOR:
        return ClinicalCoordinatorAppRoutes
      case ROLES.SALES_REPRESENTATIVE:
        return SalesRepresentativeAppRoutes
      case ROLES.VENDOR_ANALYST:
      case ROLES.VENDOR_LEGAL:
        return VLegalVAnalystLegalAppRoutes
      case ROLES.LEGAL:
        return LegalAppRoutes
      case ROLES.VENDOR_FINANCE_OFFICER:
        return VendorFinanceOfficerAppRoutes
      case ROLES.COMMUNITY_RCA:
        return RevenueCycleAdvisorAppRoutes
      case ROLES.FINANCE:
        return CommunityFinanceAppRoutes
      case ROLES.ANALYST:
        return AnalistAppRoutes
      case ROLES.COMMONS_LEGAL:
        return CommonsLegalAppRoutes
      case ROLES.COMMONS_ANALYST:
        return CommonsAnalystAppRoutes
      case ROLES.COMMONS_STAKEHOLDER:
        return CommonsStAppRoutes
      case ROLES.COMMONS_VICE_PRESIDENT:
        return CommonsVpAppRoutes
      case ROLES.COMMONS_CLINICAL_COORDINATOR:
        return CommonsCCAppRoutes
      case ROLES.COMMONS_CONTRACT_STEWARD:
        return CommonsCSAppRoutes
      case ROLES.COMMUNITY_PRESIDENT:
        return CommunityPresident
      case ROLES.GPO_PRESIDENT:
        return GpoPresidentRoutes
      case ROLES.GPO_FINANCE_OFFICER:
        return GpoFinOfficerRoutes
      case ROLES.GPO_LEGAL:
        return GpoLegalRoutes
      case ROLES.GPO_ANALYST:
        return GpoAnalystRoutes
      case ROLES.GPO_CONTRACT_STEWARD:
        return GpoContractStewardRoutes
      default:
        return DefaultAppRoutes
    }
  }, [
    user.role,
    HospitalUserAppRoutes,
    VendorCSAppRoutes,
    VendorCAAppRoutes,
    HospitalAdminAppRoutes,
    ClinicalCoordinatorAppRoutes,
    SalesRepresentativeAppRoutes,
    VLegalVAnalystLegalAppRoutes,
    LegalAppRoutes,
    VendorFinanceOfficerAppRoutes,
    RevenueCycleAdvisorAppRoutes,
    CommunityFinanceAppRoutes,
    AnalistAppRoutes,
    CommonsLegalAppRoutes,
    CommonsAnalystAppRoutes,
    CommonsStAppRoutes,
    CommonsVpAppRoutes,
    CommonsCCAppRoutes,
    CommonsCSAppRoutes,
    CommunityPresident,
    GpoPresidentRoutes,
    GpoFinOfficerRoutes,
    GpoLegalRoutes,
    GpoAnalystRoutes,
    GpoContractStewardRoutes,
    DefaultAppRoutes
  ])

  const LoginRoutes = useMemo(
    () => (
      <>
        {process.env.REACT_APP_OLD_LOGIN_ENABLED === 'true' && (
          <Route path={routes.loginOld} element={<SignIn />} />
        )}
        <Route path={routes.login} element={<DescopeSignIn />} />
        <Route path={routes.userNotExist} element={<UserNotExist />} />
        <Route path={routes.completeProfile} element={<CompleteProfile />} />
        <Route path={routes.selfSignUp} element={<SelfSignUp />} />
        <Route path={routes.confirmEmail} element={<EmailConfirmation />} />
        <Route path={routes.resetPassword} element={<EmailConfirmation />} />
        <Route path={routes.setPassword} element={<SignUp />} />
        <Route path={routes.faNumber} element={<FANumber />} />
        <Route path={routes.faCode} element={<FACode />} />
        <Route path={routes.verifyEmail} element={<VerifyEmail />} />
        <Route path={routes.linkExpired} element={<LinkExpired />} />
        <Route path={routes.pendingApproval} element={<PendingApproval />} />
        <Route path={routes.termsOfUse} element={<TermsOfUsePage />} />
        <Route path={routes.landing} element={<LandingPage />} />
        <Route path="*" element={<Navigate to={routes.landing} replace />} />
      </>
    ),
    []
  )
  const { push } = useRouter()

  useEffect(() => {
    if (user.uuid) {
      const page = getLocalLastPage()
      if (page) {
        push(page)
        setLocalLastPage('')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.uuid])

  return (
    <>
      {!user.uuid && pathname === routes.landing && (
        <Routes>
          <Route path={routes.landing} element={<LandingPage />} />
          <Route path="*" element={<Navigate to={routes.landing} replace />} />
        </Routes>
      )}
      {pathname !== routes.landing && (
        <Portal>
          <Routes>
            {user.uuid ? AppRoutes : LoginRoutes}

            {((user.role.includes('vendor') && hasVendorFullAccess) ||
              !user.role.includes('vendor')) && (
              <Route path={routes.financials} element={<Financials />}>
                <Route path=":tab" element={<Financials />} />
                <Route path=":tab/:type" element={<Financials />} />
              </Route>
            )}

            <Route path={routes.notFound} element={<PageNotFound />} />
            <Route
              path="*"
              element={<Navigate to={routes.notFound} replace />}
            />
          </Routes>
        </Portal>
      )}
    </>
  )
}
